import { ReactElement } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Box } from '@mui/material'
import { GenericErrorBoundaryFallback } from '@ui/errors'
import { Navbar } from '@ui/navigation'

interface Props {
  children: ReactElement
  disablePadding?: boolean
}

const Layout = ({ children, disablePadding = false }: Props): ReactElement => {
  return (
    <Box sx={{ height: '100vh' }}>
      <Navbar />
      <Box
        sx={({ distances }) => ({
          height: distances.navBarHeight,
          flexShrink: 0,
          '@media (min-width: 1920px)': { height: distances.navBarHeightExpanded },
          boxSizing: 'border-box',
        })}
      />
      <Box
        sx={({ palette, spacing, distances }) => ({
          backgroundColor: palette.grey[200],
          padding: disablePadding ? 0 : spacing(3),
          boxSizing: 'border-box',
          height: `calc(100vh - ${distances.navBarHeight})`,
          '@media (min-width: 1920px)': {
            height: `calc(100vh - ${distances.navBarHeightExpanded})`,
          },
          overflowY: 'auto',
        })}
      >
        <ErrorBoundary FallbackComponent={GenericErrorBoundaryFallback}>{children}</ErrorBoundary>
      </Box>
    </Box>
  )
}

export default Layout
